import {
  queryBrand,
  saveBrand,
  fetchInfo
} from '../services/api';

export default {
  namespace: 'account',

  state: {
    brandData: {},
    loading: true,
    flag: false,
    sponsorInfo: {}
  },

  effects: {
    *queryBrand({ payload, callback }, { call, put }) {
      yield put({
        type: 'changeLoading',
        payload: true,
      });
      const response = yield call(queryBrand, payload);
      yield put({
        type: 'saveList',
        payload: response,
      });
      yield put({
        type: 'changeLoading',
        payload: false,
      });
      if (callback) callback();
    },

    *queryAvailableBrand({ payload }, { call, all }) {
      const [passed, latest] = yield all([
        call(queryBrand, { ...payload, auditStatus: 1021 }),
        call(queryBrand, payload),
      ])

      const passedLogo = (passed || {}).logo
      const latestLogo = (latest || {}).logo
      const result = { brandData: passed }

      if (passedLogo && latestLogo) {
        return { status: 'OK', ...result }
      } else if (!latestLogo) {
        return { status: 'NEVER_UPLOAD', ...result }
      } else if (!passedLogo) {
        return { status: 'WAIT_AUDIT', ...result }
      }
    },

    *saveBrand({ payload, callback }, { call, put }) {
      const response = yield call(saveBrand, payload);
      yield put({
        type: 'createStatus',
        payload: response,
      });
      if (callback) callback();
    },

    *fetchInfo(_, { call, put }) {
      const response = yield call(fetchInfo);
      yield put({
        type: 'saveInfo',
        payload: response,
      });
    },

  },

  reducers: {
    saveList(state, action) {
      return {
        ...state,
        brandData: action.payload,
      };
    },

    createStatus(state, action) {
      return {
        ...state,
        flag: action.payload,
      };
    },

    changeLoading(state, action) {
      return {
        ...state,
        loading: action.payload,
      };
    },

    saveInfo(state, { payload }) {
      return {
        ...state,
        sponsorInfo: payload || {},
      }
    },
  },
};
